import { Component, EventEmitter, inject, Input, OnDestroy, Output } from '@angular/core';
import { MessagesService } from '../../../../services/campaign/messages.service';
import { UserProfileService } from '../../../../services/user/user-profile.service';
import { SendTestMessageModalComponent } from '../../send-test-message-modal/send-test-message-modal.component';
import { RecipientsService } from '../../../../services/campaign/recipients.service';
import { SmsBubbleComponent } from '../../../messages/sms-bubble/sms-bubble.component';
import { WizardAudienceService } from '../../../../pages/organization/campaigns/create-campaign/wizard-audience.service';
import { SmsParts, formatCount, smsParts } from '../../../../../utils/sms';

/** The draft as a handset shows it, the audience it reaches, and a test send. */
@Component({
  selector: 'app-test-message',
  standalone: true,
  imports: [SendTestMessageModalComponent, SmsBubbleComponent],
  templateUrl: './test-message.component.html',
  styleUrl: './test-message.component.css',
})
export class TestMessageComponent implements OnDestroy {
  @Output() closeTestMessage = new EventEmitter();
  @Input({ required: true }) fromEdit!: boolean; //to check if preview message is clicked from edit message component
  messagesService = inject(MessagesService);
  userService = inject(UserProfileService);
  recipientsService = inject(RecipientsService);
  audience = inject(WizardAudienceService);

  readonly formatCount = formatCount;

  /** The shared test window is open. */
  selectTestUser = false;

  /** Unique recipients of the chosen groups (POST preview/recipient-count). */
  get recipientCount(): number {
    return this.audience.count ?? 0;
  }

  get isFetchingCount(): boolean {
    return this.audience.loading;
  }

  get institutionName() {
    return this.userService.getInstitutionName;
  }

  get totalMessages() {
    return this.messagesService.savedMessages.length;
  }

  get parts(): SmsParts {
    return smsParts(this.messagesService.messages.body);
  }

  /** SMS one send of this message costs: parts × unique recipients. */
  get units(): number | null {
    if (this.audience.count === null || !this.parts.parts) return null;
    return this.parts.parts * this.audience.count;
  }

  backToMessages() {
    // if preview is from the edit message component, it should clear message service messages
    if (this.fromEdit) {
      this.messagesService.messages = {
        subject: '',
        body: '',
        hashtags: [],
        senderId: '',
      };
    }
    this.closeTestMessage.emit();
  }

  ngOnDestroy() {
    // if preview is from the edit message component, it should clear message service messages
    if (this.fromEdit) {
      this.messagesService.messages = {
        subject: '',
        body: '',
        hashtags: [],
        senderId: '',
      };
    }
  }

  ngOnInit() {
    this.fetchRecipientCount();
  }

  /** Same POST preview/recipient-count as before, shared with the other steps. */
  fetchRecipientCount() {
    this.audience.refresh();
  }
}
